// extracted by extract-css-chunks-webpack-plugin
module.exports = {"news_box":"news_box-3RzDtrsX clearfix"};